<script setup>
// The shared shell for every full-screen auth console screen (#2230): login,
// auth callback, logout, and the brand picker. Owns the ground, the gradient
// frame, the terminal header bar, and the KHK ADMIN PORTAL wordmark, so those
// live in exactly one place. Styling is in assets/auth-screen.css.
</script>

<template>
    <div class="auth-screen flex items-center justify-center min-h-screen min-w-[100vw] overflow-hidden">
        <div class="flex flex-col items-center justify-center w-full max-w-[32rem] px-4">
            <div class="auth-console-frame">
                <div class="auth-console-card">
                    <div class="con-bar">
                        <span class="con-dot live"></span>
                        <span class="con-dot"></span>
                        <span class="con-dot"></span>
                    </div>
                    <div class="con-word">KHK ADMIN PORTAL</div>

                    <slot />
                </div>
            </div>

            <!-- Sits outside the frame, e.g. the login screen's copyright line. -->
            <slot name="footer" />
        </div>
    </div>
</template>
